import AppCompoentBase from './app-component-base';


const ModalComponentBase = {
    mixins: [AppCompoentBase],
    props: ["modelRef", "modelData"],
    computed: {},
    methods: {
        success(result) {
            if (typeof (result) !== 'boolean') {
                this.modelRef.close(result);
                return;
            }
            this.modelRef.close(true);
        },
        close() {
            this.modelRef.close(false);
        },
        confirm(data){
            this.modelRef.confirm(data);
        },
        fullData() {
            if (this.modelData) {
                // console.log('-------------------ModalComponentBase----------------------')
                for (let key  in this.modelData) {
                     if (key == 'formModel'){
                          if (this.modelData[key] == {} ||this.modelData[key] == null){
                               continue
                          }
                     }
                    this[key] = this.modelData[key];
                }
            }
        }
    },
};

export default ModalComponentBase;

